import React from "react";
import { LOGO_URL } from "../../config";
import "./AdminSidebar.css";

export const ADMIN_TABS = [
  { id: "overview",   icon: "📊", label: "Overview"      },
  { id: "episodes",   icon: "🎬", label: "Episodes"       },
  { id: "blog",       icon: "✍️",  label: "Blog Posts"     },
  { id: "guests",     icon: "👥", label: "Guests"         },
  { id: "live",       icon: "🔴", label: "Live Stream"    },
  { id: "breaking",   icon: "⚡", label: "Breaking News"  },
  { id: "about",      icon: "📋", label: "About / Bio"    },
  { id: "newsletter", icon: "📧", label: "Newsletter"     },
  { id: "contact",    icon: "📩", label: "Messages"       },
];

export default function AdminSidebar({ tab, setTab, onExit, isOpen }) {
  return (
    <aside className={`admin-sidebar${isOpen ? " is-open" : ""}`}>
      <div className="admin-sidebar-logo">
        <img src={LOGO_URL} alt="Logo" />
        <span>Admin<br />Panel</span>
      </div>

      <nav className="admin-nav">
        {ADMIN_TABS.map((t) => (
          <button
            key={t.id}
            className={`admin-nav-item ${tab === t.id ? "active" : ""}`}
            onClick={() => setTab(t.id)}
          >
            <span className="nav-icon">{t.icon}</span>
            {t.label}
          </button>
        ))}

        <button className="admin-nav-item admin-nav-exit" onClick={onExit}>
          <span className="nav-icon">🌐</span>
          View Site
        </button>
      </nav>
    </aside>
  );
}
